import * as yup from 'yup';

import { Task } from 'src/common/interfaces/manage-room';

export const taskFormInitialValues: Task = {
  taskNo: 0,
  _id: '',
  type: 'none',
  title: '[New Task]',
  description: '<p>Change me</p>',
  objective: '',
  releaseDate: null,
  expirationDate: null,
  deadline: null,
  uploadId: '',
  roomId: '',
  roomCode: '',
  infoList: [
    {
      questionNo: 1,
      question: '<p>Update me..</p>',
      answer: '',
      hint: '',
      _id: '',
      deleted: false,
    },
  ],
};

const QuestionSchema = yup.object({
  questionNo: yup.number(),
  question: yup.string().required().label('Question'),
  answer: yup.string(),
  hint: yup.string(),
  prompts: yup.string(),
  _id: yup.string(),
  delete: yup.boolean(),
});

export const TaskValidation = yup.object({
  title: yup.string().required().label('Title'),
  infoList: yup.array().of(QuestionSchema).required(),
});
